// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1S6ix","content":"LoadingAlert_content__26X6x"};